import * as React from "react";
import Carousel from "react-material-ui-carousel";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import { CSSProperties } from "@emotion/serialize";

interface NavButtonProps {
  onClick: Function;
  className: string;
  style: CSSProperties;
  next: boolean;
  prev: boolean;
}

const useStyles = makeStyles((theme) => ({
  carouselDiv: {
    width: "100%",
  },
  navButtonWrapper: {
    display: "flex",
    alignItems: "center",
    background: "none",
    '&:hover button': {
      backgroundColor: 'rgba(25, 118, 210, 0.04) !important',
      opacity: '1 !important',
    },
  },
}));

export default function CarouselComp(props: any) {
  const classes = useStyles();
  return (
    <div className={classes.carouselDiv}>
      <Carousel
        autoPlay={false}
        navButtonsAlwaysVisible={true}
        animation="slide"
        indicators={false}
        cycleNavigation={false}
        NextIcon={<ChevronRightIcon />}
        fullHeightHover={false}
        navButtonsWrapperProps={{
          className: classes.navButtonWrapper,
        }}
        NavButton={({ onClick, className, style, next, prev }: NavButtonProps) => {
          return (
            <Button onClick={(e) => onClick(e)} sx={{ color: "black" }}>
              {next && <ChevronRightIcon style={{ color: "#14142B", marginLeft: "20px" }} />}
              {prev && <ChevronLeftIcon style={{ color: "#14142B", marginRight: "20px" }} />}
            </Button>
          );
        }}
      >
        {props.children}
      </Carousel>
    </div>
  );
}
